module.exports = __webpack_public_path__ + "img/remove_icon.68e5d8fc.svg";